import { axiosInstance } from "../axios";

export const nhomNguyenVatLieuApi = {
  getAll: async (params) => {
    return axiosInstance.get("/material_groups/search", { params });
  },
  create: async (body) => {
    return axiosInstance.post("/material_groups/create", body);
  },
  update: async (body) => {
    return axiosInstance.post("/material_groups/update", body);
  },
};
